export default {
  showResultTally: false,
  showExitPoll: false,
  showKeyCand: true,
  resultVersion: 10.1,
  exitPollVersion: 1.1,
  electionYear: 2024,
  isElectionAlpha: false,
  showSponsor: false,
};
  